import { createReducer } from 'modules/util'
import { REHYDRATE } from 'redux-persist/constants'

import ActionType from '../constants/actionTypes'

export const initialState = {
  loaded: false,
  selectedQuestion: null,
  questions: [
    {
      question: null,
      arguments: []
    }
  ]
}

const handlers = {
  [ActionType.SELECT_QUESTION]: selectQuestion,
  [ActionType.FETCH_QUESTIONS_SUCCESS]: setQuestions,
  [REHYDRATE]: rehydrate
}

export default createReducer(initialState, handlers)

function selectQuestion(state, { payload }) {
  return { ...state, selectedQuestion: payload }
}

function setQuestions(state, { payload }) {
  return { ...state, loaded: true, questions: [...payload] }
}

function rehydrate(state) {
  return { ...state, loaded: false }
}



// WEBPACK FOOTER //
// ./client/modules/debate/reducers/question.js